import { set } from '@/utils/vuex'

export default {
  SET_CODE: set('codeDetail'),
  SET_CODE_MATRICULADOS: set('codeDetailMatriculados')
}
